import { LicenseBindingsEntityModel } from "src/store/models/entity/licenseBindings/entity";
import { LicenseBindingListModel } from "src/store/models/entity/licenseBindings/list";

export const encooLicenseModels = {
  entity: LicenseBindingsEntityModel,
  list: LicenseBindingListModel,
};
